import React, { useState } from "react";
import styles from "./ShowCards.module.css";
import Card from "../Card";
import { deleteCards } from "../../../services/CardServices";
import globalStyles from "../../../styles/globalStyles.module.css";
import { FaTimes, FaLock } from "react-icons/fa";
import { useAlert } from "../../../context/AlertProvider";
import { ShowCardsType } from "../../../services/CardServices";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ShowCards: React.FC<{
  cards: ShowCardsType[];
  disableDelete?: boolean;
  handleAddOrRemoveCards?: (cards: ShowCardsType[]) => void;
}> = ({ cards, disableDelete = true, handleAddOrRemoveCards }) => {
  const [isSelecting, setIsSelecting] = useState<boolean>(false);
  const [selectedCards, setSelectedCards] = useState<Set<number>>(new Set());
  const { showAlert } = useAlert();
  const [hiddenBooster, setHiddenBooster] = useState<Set<string>>(new Set());
  const { t } = useTranslation();

  const toggleSelectCard = (cardId: number) => {
    setSelectedCards((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(cardId)) {
        newSet.delete(cardId);
      } else {
        newSet.add(cardId);
      }
      return newSet;
    });
  };

  const toogleSelecting = () => {
    setIsSelecting(!isSelecting);
    const emptySet: Set<number> = new Set();
    setSelectedCards(emptySet);
  };

  const toogleBoosterVisibility = (boosterId: string) => {
    setHiddenBooster((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(boosterId)) {
        newSet.delete(boosterId);
      } else {
        newSet.add(boosterId);
      }
      return newSet;
    });
  };

  const handleDeleteCards = async () => {
    try {
      const numberArray = Array.from(selectedCards);

      const res = await deleteCards(numberArray);

      if (res.errors.boosterCards?.length > 0) {
        showAlert(
          t("alert.cards.delete.error.inBooster", {
            count: res.errors.boosterCards.length,
          })
        );
      }

      if (res.errors.collectorCards?.length > 0) {
        showAlert(
          t("alert.cards.delete.error.bought", {
            count: res.errors.collectorCards.length,
          })
        );
      }

      showAlert(
        t("alert.cards.delete.success", {
          count: res.deletedIds.length,
        })
      );
      if (res.deletedIds.length > 0) {
      }

      if (!handleAddOrRemoveCards) return;
      var newCards = cards.filter((card) => !res.deletedIds.includes(card.id));

      handleAddOrRemoveCards(newCards);
    } catch {
      showAlert(t("alert.cards.delete.error.default"));
    }
  };

  // const handleArchiveCards = async () => {
  //   try {
  //     const numberArray = Array.from(selectedCards);
  //     await archiveCards(numberArray);

  //     showAlert(
  //       t("alert.cards.update.archive.success", {
  //         count: numberArray.length,
  //       })
  //     );

  //     if (!handleAddOrRemoveCards) return;
  //     var newCards = cards.filter((card) => !numberArray.includes(card.id));

  //     handleAddOrRemoveCards(newCards);
  //   } catch {
  //     showAlert(t("alert.cards.update.archive.error"));
  //   }
  // };

  // const handlePrintCards = async () => {
  //   cards.forEach((c) => {
  //     if (selectedCards.has(c.id)) {
  //       addToCart({ card: c, quantity: 1 });
  //     }
  //   });
  // };

  const groupedCards = cards.reduce<Record<string, ShowCardsType[]>>(
    (acc, card) => {
      const key = card.booster_image;
      if (!acc[key]) acc[key] = [];
      acc[key].push(card);
      return acc;
    },
    {}
  );

  return (
    <>
      <div className={styles.selectButtonContainer}>
        <button
          className={`${globalStyles.button} ${isSelecting && styles.active}`}
          onClick={toogleSelecting}
        >
          {t("cards.select")}
        </button>
      </div>
      {isSelecting && (
        <div className={styles.actionButtonsContainer}>
          <div className={styles.actionButtons}>
            <div>
              {selectedCards.size} {t("cards.selected")}
            </div>
            <div className={styles.actionButtons}>
              {/* <button
                onClick={handlePrintCards}
                className={`${globalStyles.button}`}
              >
                Buy print
              </button> */}
              {!disableDelete && (
                <button
                  onClick={handleDeleteCards}
                  className={`${globalStyles.button}`}
                >
                  {t("delete")}
                </button>
              )}
              {/* <button
                onClick={handleArchiveCards}
                className={`${globalStyles.button}`}
              >
                {t("archive")}
              </button> */}
              <button
                className={`${globalStyles.button} ${styles.cancelButton}`}
                onClick={toogleSelecting}
              >
                <FaTimes size={25} />
              </button>
            </div>
          </div>
        </div>
      )}
      {Object.entries(groupedCards).map(([imageId, cardGroup]) => (
        <div key={imageId}>
          {imageId === "null" ? (
            <h1>{t("notUsed")}</h1>
          ) : (
            <div className={styles.boosterSection}>
              <br />
              <Link
                to={`/boosters/${cardGroup[0].booster_id}`}
                className={`${globalStyles.unset} ${styles.boosterUrl}`}
              >
                <div className={styles.boosterSectionTitle}>
                  <img
                    src={imageId}
                    alt="booster"
                    className={styles.boosterImage}
                  />
                  <strong>{cardGroup[0].booster_name}</strong>
                </div>
              </Link>
              <button
                className={`${globalStyles.button} ${styles.right}`}
                onClick={() =>
                  toogleBoosterVisibility(cardGroup[0].booster_id!)
                }
              >
                {hiddenBooster.has(cardGroup[0].booster_id!)
                  ? t("show")
                  : t("hide")}
              </button>
            </div>
          )}
          <div className={styles.cardContainer}>
            {!hiddenBooster.has(cardGroup[0].booster_id!) &&
              cardGroup.map((card) => (
                <div
                  key={card.id}
                  className={styles.cardWrapper}
                  onClick={() => {
                    isSelecting && toggleSelectCard(card.id);
                  }}
                >
                  {isSelecting && (
                    <input
                      type="checkbox"
                      checked={selectedCards.has(card.id)}
                      className={styles.selectCards}
                    />
                  )}
                  {isSelecting && card.booster_id != null && (
                    <div className={styles.lockIcon}>
                      <FaLock size={80} />
                    </div>
                  )}
                  <div
                    className={`${styles.cardWidth} ${
                      selectedCards.has(card.id) ? styles.selected : ""
                    }`}
                  >
                    <Card
                      cardData={card}
                      key={card.id}
                      disableClick={isSelecting}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default ShowCards;
